import React from 'react';
import {
  OperationByMileageOrTimeList,
  OperationByServiceList,
} from '@1po/1po-bff-fe-spec/generated/catalog/maintenance_plan/response/GetMaintenancePlanResponse';
import { MaintenanceViewProps } from 'pages/CatalogPage/DH/Maintenance/Maintenance';
import { OperationTable } from 'pages/CatalogPage/DH/Maintenance/Maintenance.styled';
import { getServiceColumns } from 'pages/CatalogPage/DH/Maintenance/Maintenance.utils';
import { Box, Flex, Text } from 'UI';

const splitOperations = (operations: OperationByServiceList[]) => {
  const middleIndex = Math.ceil(operations.length / 2);
  const table1Data = operations.slice().splice(0, middleIndex);
  const table2Data = operations.slice().splice(middleIndex);
  return [table1Data, table2Data];
};

const Services = ({
  operationByServiceList,
  operationByMileageOrTimeList,
  printView,
  idServices = [],
}: {
  operationByMileageOrTimeList: OperationByMileageOrTimeList[];
  operationByServiceList: OperationByServiceList[];
  idServices: number[];
  printView?: boolean;
}) => {
  const [table1Data, table2Data] = splitOperations(operationByServiceList);
  const columns = getServiceColumns(idServices, operationByMileageOrTimeList, printView);
  return (
    <Flex direction={'row'} gap={printView ? 15 : 33}>
      <OperationTable columns={columns} dataSource={table1Data} pagination={false} rowKey={'label'} bordered />
      {table2Data.length > 0 ? (
        <OperationTable columns={columns} dataSource={table2Data} pagination={false} rowKey={'label'} bordered />
      ) : (
        <Flex />
      )}
    </Flex>
  );
};

const ServiceSection = ({ maintenancePlanData, getLabel, printView }: MaintenanceViewProps) => {
  if (maintenancePlanData.operationByServiceList.length === 0) return <></>;

  return (
    <Flex direction={'column'}>
      <Text type={'h5_bold'}>{getLabel(28)}</Text>
      <Box height={30} />
      <Services
        operationByServiceList={maintenancePlanData.operationByServiceList}
        idServices={maintenancePlanData.operationsByServiceIds}
        operationByMileageOrTimeList={maintenancePlanData.operationByMileageOrTimeList}
        printView={printView}
      />
    </Flex>
  );
};
export default ServiceSection;
